import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-info__items account-info__multiple" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"35px"} }, "收益人信息", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","color":"red"} }, " 1.请填写实际收益比例超过25%的受益人；2.最少填写1组，最多填写4组股东信息 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "enterprise-real-form-upload" }, " 请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过 5M； ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "enterprise-real-form-upload" }, " 请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过 5M； ", -1)

import { computed } from 'vue';
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseSelect,
  BaseTextContent,
  BaseTextTitle,
  BaseButton
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-beneficiary',
  setup(__props) {

const CERT_TP_OPTIONS = [
  { label: '身份证', value: '0' },
  { label: '外国护照', value: '1' }
];
const BENEFICIARY_TYPE_OPTIONS = [
  { label: '股权', value: '01' },
  { label: '表决权', value: '02' },
  { label: '高级管理员人员', value: '03' },
  { label: '其他', value: '04' }
];

const { formData, formRef, disabled } = storeToRefs(infoStore());
const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, [
    'fyBeneficiaryInfoList.portraitFilePath',
    'fyBeneficiaryInfoList.badgeFilePath'
  ]);

const addDisabled = computed(() => {
  return formData.value.fyBeneficiaryInfoList.length >= 4 || disabled.value;
});

const defProp = (index, key) => {
  return `fyBeneficiaryInfoList.${index}.${key}`;
};

const onAdd = () => {
  if (addDisabled.value) return;
  formData.value.fyBeneficiaryInfoList.push({
    name: '',
    certTp: '0',
    certNo: '',
    validDateStart: '',
    validDateEnd: '',
    mobile: '',
    address: '',
    portraitFilePath: '',
    badgeFilePath: '',
    beneficiaryType: null
  });
};
const onDelete = index => {
  if (!index) return;
  formData.value.fyBeneficiaryInfoList.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _hoisted_2,
        (!_unref(disabled))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(BaseButton), {
                disabled: addDisabled.value,
                onClick: onAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _hoisted_3
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).fyBeneficiaryInfoList, (item, index) => {
      return (_openBlock(), _createBlock(_unref(BaseTextContent), {
        key: index + '_' + Date.now(),
        class: "account-info__content"
      }, {
        default: _withCtx(() => [
          (index && !_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(BaseButton), {
                key: 0,
                class: "account-info__multiple__delete",
                onClick: ($event: any) => (onDelete(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(BaseFormItem), {
            label: "姓名",
            prop: defProp(index, 'name'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                type: "text",
                placeholder: "请输入",
                modelValue: item.name,
                "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            label: "证件类型",
            prop: defProp(index, 'certTp'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseSelect), {
                placeholder: "请选择",
                options: CERT_TP_OPTIONS,
                modelValue: item.certTp,
                "onUpdate:modelValue": ($event: any) => ((item.certTp) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            label: "手机号",
            prop: defProp(index, 'mobile'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                type: "tel",
                placeholder: "请输入",
                clearable: "",
                maxlength: 11,
                modelValue: item.mobile,
                "onUpdate:modelValue": ($event: any) => ((item.mobile) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            label: "证件号",
            prop: defProp(index, 'certNo'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                type: "text",
                placeholder: "请输入",
                inputTextReplace: "",
                inputTexts: ['英文字母', '数字'],
                modelValue: item.certNo,
                "onUpdate:modelValue": ($event: any) => ((item.certNo) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            label: "地址",
            prop: defProp(index, 'address'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                type: "text",
                placeholder: "请输入",
                modelValue: item.address,
                "onUpdate:modelValue": ($event: any) => ((item.address) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            label: "收益方式",
            prop: defProp(index, 'beneficiaryType'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseSelect), {
                placeholder: "请选择",
                options: BENEFICIARY_TYPE_OPTIONS,
                modelValue: item.beneficiaryType,
                "onUpdate:modelValue": ($event: any) => ((item.beneficiaryType) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BizFormTimes), {
            class: "account-info__block",
            label: "证件有效期",
            startProp: defProp(index, 'validDateStart'),
            endProp: defProp(index, 'validDateEnd'),
            start: _unref(formData).fyBeneficiaryInfoList[index].validDateStart,
            "onUpdate:start": ($event: any) => ((_unref(formData).fyBeneficiaryInfoList[index].validDateStart) = $event),
            end: _unref(formData).fyBeneficiaryInfoList[index].validDateEnd,
            "onUpdate:end": ($event: any) => ((_unref(formData).fyBeneficiaryInfoList[index].validDateEnd) = $event)
          }, null, 8, ["startProp", "endProp", "start", "onUpdate:start", "end", "onUpdate:end"]),
          _createVNode(_unref(BaseFormItem), {
            style: {"grid-column-start":"1","grid-column-end":"3"},
            label: "身份证照片（人像面）",
            prop: defProp(index, 'portraitFilePath'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseUpload), {
                style: {"width":"100%"},
                ref_for: true,
                ref: "portraitFilePathRef",
                listType: "picture-card",
                disabled: _unref(disabled),
                accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                drag: false,
                limit: 1,
                limitSize: 5,
                multiple: false,
                "auto-upload": true,
                onError: _unref(onUploadErr),
                "http-request": _unref(uploadApi),
                beforeRemove: 
            (file, remove) => {
              remove();
              _unref(onUploadRemove)('fyBeneficiaryInfoList.portraitFilePath', index);
              return true;
            }
          ,
                fileList: _unref(uploadModelMap)[defProp(index, 'portraitFilePath')],
                "onUpdate:fileList": ($event: any) => ((_unref(uploadModelMap)[defProp(index, 'portraitFilePath')]) = $event),
                onChange: 
            v =>
              _unref(onUploadChange)(v, 'fyBeneficiaryInfoList.portraitFilePath', index)
          
              }, {
                tip: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["disabled", "onError", "http-request", "beforeRemove", "fileList", "onUpdate:fileList", "onChange"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(_unref(BaseFormItem), {
            style: {"grid-column-start":"3","grid-column-end":"5"},
            label: "身份证照片（国徽面）",
            prop: defProp(index, 'badgeFilePath'),
            rules: [
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseUpload), {
                style: {"width":"100%"},
                ref_for: true,
                ref: "badgeFilePathRef",
                listType: "picture-card",
                disabled: _unref(disabled),
                accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                drag: false,
                limit: 1,
                limitSize: 5,
                multiple: false,
                "auto-upload": true,
                onError: _unref(onUploadErr),
                "http-request": _unref(uploadApi),
                beforeRemove: 
            (file, remove) => {
              remove();
              _unref(onUploadRemove)('fyBeneficiaryInfoList.badgeFilePath', index);
              return true;
            }
          ,
                fileList: _unref(uploadModelMap)[defProp(index, 'badgeFilePath')],
                "onUpdate:fileList": ($event: any) => ((_unref(uploadModelMap)[defProp(index, 'badgeFilePath')]) = $event),
                onChange: 
            v => _unref(onUploadChange)(v, 'fyBeneficiaryInfoList.badgeFilePath', index)
          
              }, {
                tip: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["disabled", "onError", "http-request", "beforeRemove", "fileList", "onUpdate:fileList", "onChange"])
            ]),
            _: 2
          }, 1032, ["prop"])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})